import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { Box } from '@mui/material';

const LoginLayout = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <Header />
      <Box
        sx={{
          flex: '1 0 auto', 
          overflowY: 'auto', 
          display:"flex",
          alignItems:"center",
          justifyContent:"center"
        }}
      >
        <Outlet />
      </Box>
      <Footer />
    </Box>
  );
};

export default LoginLayout;
